import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Newspaper, FolderTree, Tags, Image, Mic2, MessageSquare, Home, Users, Mail, LogOut, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Табло", icon: LayoutDashboard, exact: true },
  { to: "/admin/articles", label: "Статии", icon: Newspaper },
  { to: "/admin/categories", label: "Категории", icon: FolderTree },
  { to: "/admin/tags", label: "Тагове", icon: Tags },
  { to: "/admin/media", label: "Медия", icon: Image },
  { to: "/admin/podcasts", label: "Подкасти", icon: Mic2 },
  { to: "/admin/comments", label: "Коментари", icon: MessageSquare },
  { to: "/admin/homepage", label: "Начална страница", icon: Home },
  { to: "/admin/dimovsky-sync", label: "Dimovsky синх.", icon: RefreshCw },
  { to: "/admin/newsletter", label: "Digest Preview", icon: Mail },
  { to: "/admin/contacts", label: "Контакти", icon: Users },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#F4F1EC]" data-testid="admin-layout">
      <aside className="w-64 bg-[#111827] text-[#CBD5E0] flex flex-col" data-testid="admin-sidebar-nav">
        <div className="px-6 py-5 font-serif text-xl font-bold text-white border-b border-[#1F2937]">
          Metri<span className="text-[#C5A059]">.bg</span> <span className="text-xs font-sans text-[#9CA3AF]">Admin</span>
        </div>
        <nav className="flex-1 py-4">
          {NAV.map(({ to, label, icon: Icon, exact }) => (
            <NavLink
              key={to}
              to={to}
              end={exact}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 text-sm font-medium ${isActive ? "bg-[#1F2937] text-white border-r-2 border-[#A6192E]" : "hover:bg-[#1F2937]/60"}`
              }
              data-testid={`admin-nav-${label}`}
            >
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-6 py-4 border-t border-[#1F2937] text-sm">
          <div className="text-white font-medium">{user?.name}</div>
          <div className="text-[#9CA3AF] text-xs uppercase tracking-wide">{user?.role}</div>
          <button onClick={() => { logout(); navigate("/"); }} className="mt-3 flex items-center gap-2 text-[#9CA3AF] hover:text-white text-xs" data-testid="admin-logout-btn">
            <LogOut className="w-3.5 h-3.5" /> Изход
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-6xl mx-auto px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
